import {apiRequest} from "./apiRequest";
import type {
  Invoice,
  InvoiceBulkDownloadFilterRequest,
  InvoiceBulkDownloadResponse,
  InvoiceDetailsResponse,
} from "../types/invoice";

export async function getInvoices(options?: { includeDeleted?: boolean }): Promise<Invoice[]> {
  const query = options?.includeDeleted ? "?includeDeleted=true" : "";
  return apiRequest<Invoice[]>({path: `admin/invoices${query}`});
}

export async function getInvoiceById(id: string): Promise<InvoiceDetailsResponse> {
  return apiRequest<InvoiceDetailsResponse>({path: `admin/invoices/${id}`});
}

export async function deleteInvoice(id: string): Promise<void> {
  return apiRequest<void>({path: `admin/invoices/${id}`, method: "DELETE"});
}

export async function bulkDownloadInvoices(
  request: InvoiceBulkDownloadFilterRequest,
): Promise<InvoiceBulkDownloadResponse> {
  return apiRequest<InvoiceBulkDownloadResponse>({
    path: "admin/invoices/bulkDownload",
    method: "POST",
    body: request,
  });
}
